import img1 from '../../Assete/gellery Image/productImage/1 grey.jpg'
import img2 from '../../Assete/gellery Image/productImage/25.jpg'
import img3 from '../../Assete/gellery Image/productImage/2Y8A5227 copy.jpg'
import img4 from '../../Assete/gellery Image/productImage/2Y8A5381 copy.jpg'
import img5 from '../../Assete/gellery Image/productImage/2Y8A5583 copy.jpg'
import img6 from '../../Assete/gellery Image/productImage/39.jpg'
import img7 from '../../Assete/gellery Image/productImage/13.jpg'
import img8 from '../../Assete/gellery Image/productImage/2Y8A9606.jpg'
import img9 from '../../Assete/gellery Image/productImage/3.jpg'
import img10 from '../../Assete/gellery Image/productImage/Double Side Clock-4.jpg'
import img11 from '../../Assete/gellery Image/productImage/Revive 2.jpg'
import img12 from '../../Assete/gellery Image/productImage/04.jpg'
import img13 from '../../Assete/gellery Image/productImage/2Y8A8844.jpg'
import img14 from '../../Assete/gellery Image/productImage/7.jpg'
import img15 from '../../Assete/gellery Image/productImage/phone 1.jpg'
import img16 from '../../Assete/gellery Image/productImage/phone.jpg'
import img17 from '../../Assete/gellery Image/fachion/03.jpg'
import img18 from '../../Assete/gellery Image/fachion/04 (1).jpg'
import img19 from '../../Assete/gellery Image/fachion/1 (3).jpg'
import img20 from '../../Assete/gellery Image/fachion/2.jpg'
import img21 from '../../Assete/gellery Image/fachion/2Y8A8508.jpg'
import img22 from '../../Assete/gellery Image/fachion/Retouching 1.jpg'
import img23 from '../../Assete/gellery Image/fachion/Retouching 2.jpg'
import img24 from '../../Assete/gellery Image/fachion/2.jpg'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
// import img17 from '../../Assete/gellery Image/fachion/'
export const gelleryData = [
     {
        name:"Product Photography",
        img:img1,
        slug:"product-photography",
        imageData: [
        {
            data: [{
                img: img1,
                idx: 0
            },
            {
                img: img2,
                idx: 1
            }
            ]
        },
        {
            data: [{
                img: img15,
                idx: 2
            },
            {
                img: img4,
                idx: 3
            }
            ]
        },
        {
            data: [{
                img: img5,
                idx: 4
            },
            {
                img: img6,
                idx: 5
            }
            ]
        },
        {
            data: [{
                img: img7,
                idx: 6
            },
            {
                img: img8,
                idx: 7
            }
            ]
        },
        {
            data: [{
                img: img9,
                idx: 8
            },
            {
                img: img10,
                idx: 9
            }
            ]
        },
        {
            data: [{
                img: img11,
                idx: 10
            },
            {
                img: img12,
                idx: 11
            }
            ]
        },
        {
            data: [{
                img: img13,
                idx: 12
            },
            {
                img: img14,
                idx: 13
            }
            ]
        },
        {
            data: [{
                img: img3,
                idx: 14
            },
            {
                img: img16,
                idx: 15
            }
            ]
        },


    ]
    },
    {
        name:"Fashion Shoot",
         img:img5,
        slug:"fashion-shoot",
        imageData: [
        {
            data: [{
                img: img17,
                idx: 0
            },
            {
                img: img18,
                idx: 1
            }
            ]
        },
        {
            data: [{
                img: img19,
                idx: 2
            },
            {
                img: img20,
                idx: 3
            }
            ]
        },
        {
            data: [{
                img: img21,
                idx: 4
            },
            {
                img: img22,
                idx: 5
            }
            ]
        },
        {
            data: [{
                img: img23,
                idx: 6
            },
            {
                img: img24,
                idx: 7
            }
            ]
        },
        {
            data: [{
                img: img17,
                idx: 8
            },
            {
                img: img18,
                idx: 9
            }
            ]
        },
        {
            data: [{
                img: img19,
                idx: 10
            },
            {
                img: img20,
                idx: 11
            }
            ]
        },
        {
            data: [{
                img: img21,
                idx: 12
            },
            {
                img: img22,
                idx: 13
            }
            ]
        },
        {
            data: [{
                img: img23,
                idx: 14
            },
            {
                img: img24,
                idx: 15
            }
            ]
        },


    ]
    }
    // ,{
    //     name:"Ghost Mannequin Photography",
    //     img:img2,
    //     slug:"ghost-mannequin-photography",
    //     imageData: [
    //     {
    //         data: [{
    //             img: img1,
    //             idx: 0
    //         },
    //         {
    //             img: img2,
    //             idx: 1
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img3,
    //             idx: 2
    //         },
    //         {
    //             img: img4,
    //             idx: 3
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img5,
    //             idx: 4
    //         },
    //         {
    //             img: img6,
    //             idx: 5
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img7,
    //             idx: 6
    //         },
    //         {
    //             img: img8,
    //             idx: 7
    //         }
    //         ]
    //     },


    // ]
    // },{
    //     name:"Fashion Photography",
    //     img:img3,
    //     slug:"fashion-photography",
    //     imageData: [
    //     {
    //         data: [{
    //             img: img1,
    //             idx: 0
    //         },
    //         {
    //             img: img2,
    //             idx: 1
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img3,
    //             idx: 2
    //         },
    //         {
    //             img: img4,
    //             idx: 3
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img5,
    //             idx: 4
    //         },
    //         {
    //             img: img6,
    //             idx: 5
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img7,
    //             idx: 6
    //         },
    //         {
    //             img: img8,
    //             idx: 7
    //         }
    //         ]
    //     },


    // ]
    // }
    // ,{
    //     name:"Baby Photography",
    //     img:img4,
    //     slug:"baby-photography",
    //     imageData: [
    //     {
    //         data: [{
    //             img: img1,
    //             idx: 0
    //         },
    //         {
    //             img: img2,
    //             idx: 1
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img3,
    //             idx: 2
    //         },
    //         {
    //             img: img4,
    //             idx: 3
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img5,
    //             idx: 4
    //         },
    //         {
    //             img: img6,
    //             idx: 5
    //         }
    //         ]
    //     },
    //     {
    //         data: [{
    //             img: img7,
    //             idx: 6
    //         },
    //         {
    //             img: img8,
    //             idx: 7
    //         }
    //         ]
    //     },


    // ]
    // }
]